import { takeEvery, put, call } from "redux-saga/effects";

// Login Redux States
import { GET_LANG_TIME_ZONE } from "./actionTypes";
import { getLangTimeSuccess, getLangTimeFail } from "./actions";

import { getLangTime } from "../../helpers/fakebackend_helper";

export function* Get_LangTime() {
  try {
    const response = yield call(getLangTime);
    yield put(getLangTimeSuccess(response));
  } catch (error) {
    yield put(getLangTimeFail(error));
  }
}

export function* watchGet_Staff() {
  yield takeEvery(GET_LANG_TIME_ZONE, Get_LangTime);
}

// function* newParticipantSaga() {
//   yield all([fork(watchGet_Staff)])
// }

export default watchGet_Staff;
